<template>
  <e-modal
    :visible="visible"
    :title="title"
    :loading="loading"
    :width="500"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="标题"
          :validate="validateInfos.title"
          v-model:value="modelRef.title"
        />

        <e-select
          title="广告位"
          :validate="validateInfos.adSlot"
          v-model:value="modelRef.adSlot"
          :options="$store.state.app.adSlots"
          @ok="setAdSlot"
        />

        <e-input-upload
          title="广告图"
          :validate="validateInfos.imgUrl"
          v-model:value="modelRef.imgUrl"
        />

        <e-radio
          title="状态"
          v-model:value="modelRef.activeStatus"
          :options="$store.state.app.activeStatus"
        />

        <a-row style="padding-left: 2px">
          <a-col :span="7" :offset="1">
            <e-input-number title="权重" v-model:value="modelRef.rank" />
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { AdClass } from '@/apis/ad'

const useForm = Form.useForm
const api = new AdClass()
export default defineComponent({
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      loading.value = false
      visible.value = false
    }

    return {
      title,
      visible,
      loading,
      isEdit,
      modelRef,
      validateInfos,
      resetFields,
      validate,
      onClose
    }
  },

  methods: {
    open (formData) {
      if (formData) {
        this.modelRef.title = formData.title
        this.modelRef.adSlot = formData.adSlot
        this.modelRef.adSlotName = formData.adSlotName
        this.modelRef.imgUrl = formData.imgUrl
        this.modelRef.href = formData.href
        this.modelRef.activeStatus = formData.activeStatus
        this.modelRef.rank = formData.rank
        this.modelRef.linkType = formData.linkType
        this.modelRef.linkName = formData.linkName
        this.modelRef.id = formData.id

        this.title = '编辑：' + formData.title
        this.isEdit = true
      } else {
        this.modelRef = reactive(api.modelRef)
        this.title = '添加广告'
        this.isEdit = false
      }

      this.visible = true
    },
    setAdSlot (e) {
      this.modelRef.adSlotName = this.$store.state.app.adSlots.filter(x => x.value === e)[0].label
    },
    setLinkType (e) {
      this.modelRef.linkName = this.$store.state.app.linkTypes.filter(x => x.value === e)[0].label
    },
    onSubmitFun (e) {
      const data = toRaw(e)

      if (this.isEdit) {
        api.update(data).then(() => {
          this.loading = false
          this.$message.success('编辑成功')
          this.$emit('ok', data)
          this.onClose()
        })
      } else {
        delete data.id
        api.create(data).then(() => {
          this.loading = false
          this.$message.success('添加成功')
          this.$emit('ok', data)
          this.onClose()
        })
      }
    }
  }
})
</script>
